// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

const generateFullUrl = (path: string | undefined = undefined): string => {
  return path ? `${window.location.origin}/${path}` : `${window.location.origin}`;
};

export const JSON_API_URL = generateFullUrl('api/json-api');
export const VALIDATOR_API_URL = generateFullUrl('api/validator');

export const CREDENTIAL_API_URL = generateFullUrl('api/credential');
export const REGISTRY_API_URL = generateFullUrl('api/registry');
export const REWARD_DISTRIBUTION_API_URL = generateFullUrl('api/reward-distribution');
